export const requiredRule = (v: string) => !!v || 'Muss ausgefüllt sein'
